module.exports = __webpack_public_path__ + "static/media/forget.bd8c78ac.png";